/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 26th 2022, 5:22:14 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { OSActionButton, EmptyStateActionWrapper, Image } from "ui-widgets";
import Typography from "@mui/material/Typography";
import { ProcessDefinitionInfoButtonWrapper } from "./ProcessDefinitionInfoButtonWrapper";
import { OpenMarketPlaceButtonWrapper } from "prebuilt-services";

export const EmptyServicesCTA = ({ organizationName }) => {
  return (
    <EmptyStateActionWrapper
      title={
        <>
          No services yet for <b>{organizationName}</b>
        </>
      }
      description={
        <Typography>
          Get started by creating a service. All of your services will be displayed on this page but we will not deploy
          them until you tell us to.
        </Typography>
      }
      illustrationGraphic={<Image src="/img/workflow-illustration.png" />}
    >
      <ProcessDefinitionInfoButtonWrapper>
        <OSActionButton variant="contained" size="large">
          Create New Service from Scratch
        </OSActionButton>
      </ProcessDefinitionInfoButtonWrapper>

      <OpenMarketPlaceButtonWrapper>
        <OSActionButton variant="contained" size="large">
          Use Prebuilt Service Template
        </OSActionButton>
      </OpenMarketPlaceButtonWrapper>
    </EmptyStateActionWrapper>
  );
};
